import store from "@redux/store";
import {
  StyleCategoriesTreeType,
  CategoryFilterUgcData,
  LANGUAGE
} from "@type/index";
import { MultiLanguageRegion } from "./country";

const checkMultiLanguageLogicFunc = (region: string, language: string) => {
  if (region.toUpperCase() in MultiLanguageRegion) {
    return language === LANGUAGE.EN;
  } else {
    return false;
  }
};

export const CategoryFilterMapper = (
  data: Array<StyleCategoriesTreeType>
): Array<StyleCategoriesTreeType> => {
  const { region } = store.getState().config;
  const { language } = store.getState().config;
  const _arr: Array<StyleCategoriesTreeType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: CategoryFilterUgcData) => {
      const obj: StyleCategoriesTreeType = {};
      obj.id = item.id;
      obj.name = item.name;
      obj.localizedName = checkMultiLanguageLogicFunc(region, language)
        ? item.name
        : item.localizedName;
      obj.styleCount = item.styleCount;
      if (item.styleCategories && item.styleCategories.length > 0) {
        obj.styleCategories = CategoryFilterMapper(item.styleCategories);
      }
      _arr.push(obj);
    });
  }
  return _arr;
};
